var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entry)?_c('edit-buttons'):_c('start-buttons')}
var staticRenderFns = []

export { render, staticRenderFns }